<template>

  <b-modal no-close-on-backdrop ref="my-modal" size="xl" hide-footer title="Lecciones" v-on:hide="onModalHide">

    <div class="lessons-model">
      <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar por titulo"
             aria-label="Search" aria-describedby="basic-addon2" v-model="searchLessons"  v-on:keyup="loadLessons">
      <multiselect v-model="selectedTags" id="ajax" label="name" track-by="name" placeholder="Buscar por tags" open-direction="bottom" :options="tags" :multiple="true" :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="300" :limit="3" :limit-text="limitText" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="asyncFind">
        <template slot="tag" slot-scope="{ option, remove }"><span class="mb-2 custom__tag"><span>{{ option.name }}</span><span class="custom__remove" @click="remove(option)">❌</span></span></template>
        <template slot="clear" slot-scope="props">
          <div class="multiselect__clear" v-if="selectedTags.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
        </template><span slot="noResult">No se encontraron tags</span>
      </multiselect>
    </div>

    <div class="lessons-model">
      <table class="table">
        <thead>
        <tr>
          <th>Titulo</th>
          <th></th>
        </tr>
        </thead>
        <tbody v-for="(lesson, index) in lessonsItems" :key="index">
        <tr>
          <td>{{ lesson.title }}</td>
          <td><div class="col col-sm-6 col-md-6 col-lg-6 text-center">
            <b-button class="mt-3" v-on:click="saveLesson(lesson.id, )"
                      block>Agregar</b-button>
          </div></td>
        </tr>
        </tbody>

        <tbody v-if=" lessonsItems.length === 0">
        <tr >
          <td colspan="2" class="td-nhd">No hay datos</td>
        </tr>
        </tbody>
      </table>
    </div>

  </b-modal>



</template>


<script>
import Multiselect from 'vue-multiselect'
import axios from "axios";


export default {
  props: {
    parentModel: String,
  },
  components: {
    Multiselect
  },
  data() {
    return {
      lessonsItems: [],
      searchLessons: "",
      selectedTags: [],
      tags:[],
      isLoading: false,
    }
  },
  methods: {
    limitText (count) {
      return `and ${count} other countries`
    },
    saveLesson(lessonId) {
      this.$emit('saveLesson', lessonId);
    },
    asyncFind (query) {
      this.isLoading = true;
      if (query === '') return;
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/tag/list/" + query, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.tags = response.data;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    clearAll () {
      this.selectedTags = [];
    },
    loadLessons() {

      const names = this.selectedTags.map(objeto => objeto.name);
      const tagslist = names.join(',');
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/lessons/getLesssonListforAdd/", {
          params: {
            search: this.searchLessons,
            tags: tagslist
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.lessonsItems = response.data;

        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    onModalHide() {
       this.lessonsItems= '';
    },
    showModal() {
      this.$refs['my-modal'].show();
    },
  },
  watch: {
    selectedTags: function () {
      this.loadLessons();
    }
  },
}
</script>



<style scoped>

</style>
